<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import OurLocation from '$lib/PageSections/OurLocation/OurLocation.svelte';

	import staff from './images/about-us-careers-001.png';
	import youtubeThumbnail from './images/careers-YT.jpg?w=610';
</script>

<Section>
	<Image src={staff} alt="Indow acoustic consultants standing in a line." />
	<h2 class="text-left">Indow Is Hiring</h2>
	<p class="text-left">
		Join a cleantech startup team building a great company while making a
		positive difference in our world. We're committed to continuous learning as
		we innovate ever better ways to make Indow window inserts more accessible to
		customers. If you love creative collaboration and disciplined execution, we
		hope you'll apply.
	</p>
	<p class="text-left">
		Our work is challenging, but we believe in each other and promote from
		within. Some in our
		<a href="/about-indow/management-team">senior executive team</a> started in entry-level
		positions and grew to take on greater responsibility. There's no place like our
		startup culture to learn new skills and make a huge impact on the company's future.
		Each day, you'll feel satisfaction knowing your work is resulting in dramatically
		lower carbon emissions while helping people enjoy quiet, comfort and lower energy
		bills.
	</p>
	<p class="text-left">
		Hint: <a href="/about-indow">Check out our company mission & vision</a>.
		They really matter to us!
	</p>
</Section>
<Section>
	<h2 class="text-left">Diversity, Equity, and Inclusion at Indow</h2>
	<p class="text-left">
		Indow is committed to a nondiscriminatory hiring approach and we promote
		equal opportunity for employment and advancement. We respect and value
		diverse life experiences and heritages and want all voices to be valued and
		heard. We believe diversity, equity, and inclusion leads to more expansive
		and varied ideas, information, and perspectives, making us more creative and
		improving our decision-making power.
	</p>
	<p class="text-left">
		As an employee, you would have the opportunity to join the DEI committee,
		dedicated to maintaining a diverse, equitable, and inclusive environment at
		Indow. This means, affecting procedure, events, and always taking a
		transparent and strategic approach. Our most recent <a
			href="https://www.linkedin.com/pulse/centering-dei-indow-culture-sam-pardue/"
			target="_blank"
			rel="noreferrer">team member survey</a
		> received top marks on managers' ability to be inclusive and open to new ideas,
		but we always have room to grow.
	</p>
</Section>
<Section>
	<h2 class="text-left">Benefits</h2>
	<ul>
		<li><p>Medical and dental insurance</p></li>
		<li><p>Flexible Savings Account</p></li>
		<li><p>Short Term Disability</p></li>
		<li><p>Short Term Disability and AD&D/Life Insurance</p></li>
		<li><p>401K with employer match</p></li>
		<li>
			<p>
				Paid Vacation (up to two weeks in your first three years, increasing
				with tenure)
			</p>
		</li>
		<li><p>Paid Sick Leave (up to 40 hours per calendar year)</p></li>
		<li><p>Stock Options for full-time employees</p></li>
		<li>
			<p>
				Opportunities to earn additional vacation time by participating in our
				Alternative Transit or Physical Activity Incentive Programs
			</p>
		</li>
	</ul>
</Section>
<Section>
	<h2 class="text-left">Join Us!</h2>
	<p class="text-left">
		Below are the jobs we’re currently looking to fill. All positions are
		available for candidates in the Portland, OR metro area.
	</p>
	<p class="text-left">
		Depending on the position, we may accept candidates working from other areas
		of Oregon and additional states. See individual job descriptions for more
		information!
	</p>
	<p class="text-left">
		To apply to our team, please fill out our <a
			href="/static/pdfs/Employment-Application-MH-10-19-21.pdf"
			>job application
		</a>
		and send your resume to
		<a href="mailto:opportunity@indowwindows.com"
			>opportunity@indowwindows.com</a
		>
	</p>
</Section>

<Section backgroundColor="blue">
	<h2 class="text-left">OFFICE SUPPORT SPECIALIST</h2>
	<p class="text-left">
		Indow is looking for an Office Support Specialist to join our ambitious and
		growing organization. We are seeking experienced, detail oriented candidates
		who are eager to learn and work in a collaborative environment to assist
		with customer support, order processing and shipping,
		administrative/accounting support, and supply chain/inventory support.
	</p>
	<ul>
		<li><p><span class="font-bold">Work location:</span> Portland, OR</p></li>
	</ul>
	<Button
		href="https://drive.google.com/file/d/1oCb8SCy141u9F2B5L5G-wNQZQ4Y7p8XE/view"
		>Learn More about this position</Button
	>
</Section>

<Section class="max-md:py-0">
	<Youtube
		posterImageSrc={youtubeThumbnail}
		videoId="BQxcaIr9-qo"
		title="An Inside Look at the Indow Production and Manufacturing Team"
	/>
</Section>

<OurLocation />
<Awards />
<FeaturedArticles />
